import { Component, OnInit, Input,  ViewChild, ViewContainerRef, ComponentFactoryResolver, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-calendario-picker',
  templateUrl: './calendario-picker.component.html'
})
export class CalendarioPickerComponent implements OnInit {

  dataSelecionada;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<CalendarioPickerComponent>){
    if(data){
      this.dataSelecionada = data.dataSelecionada;
    }
  }

  ngOnInit(): void {
  }

  fechar = () => {
    this.dialogRef.close({dataSelecionada:this.dataSelecionada});
  }

  aoSelecionar(dataSelecionada){
    this.dataSelecionada = dataSelecionada;

    this.fechar();
  }
}
